import {
  LOAD_COLLECTIONS,
  CREATE_COLLECTION,
  UPDATE_COLLECTION,
  DELETE_COLLECTION
} from "../actions/collections";

import _ from "lodash";


export default function(state = [], action) {

  switch (action.type) {
    case LOAD_COLLECTIONS:
      console.log("Called collections reducer");
      return action.payload;
    case CREATE_COLLECTION:
      state.push(action.payload);
      // unless state changes, re-rendering won't occur
      return JSON.parse(JSON.stringify(state))
    case UPDATE_COLLECTION:
      _.remove(state, { _id: action.payload._id });
      state.push(action.payload);
      // unless state changes, re-rendering won't occur
      return JSON.parse(JSON.stringify(state))
    case DELETE_COLLECTION:
      var index = 0;
      for (var i = 0; i < state.length; i++) {
        if (state[i]._id === action.payload) {
          index = i;
        }
      }
      return [...state.slice(0, index), ...state.slice(index + 1)];
    default:
      return state;
  }
}
